/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type AddUpdateItemModal_defaultForm$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type Toolbar_defaultForm$ref: FragmentReference;
declare export opaque type Toolbar_defaultForm$fragmentType: Toolbar_defaultForm$ref;
export type Toolbar_defaultForm = {|
  +id: string,
  +$fragmentRefs: AddUpdateItemModal_defaultForm$ref,
  +$refType: Toolbar_defaultForm$ref,
|};
export type Toolbar_defaultForm$data = Toolbar_defaultForm;
export type Toolbar_defaultForm$key = {
  +$data?: Toolbar_defaultForm$data,
  +$fragmentRefs: Toolbar_defaultForm$ref,
};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "Toolbar_defaultForm",
  "type": "Form",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "id",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "FragmentSpread",
      "name": "AddUpdateItemModal_defaultForm",
      "args": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'c73b6f5becbd1c0bb0310bf9115c6152';
module.exports = node;
